import { Trans } from 'next-i18next';
import { FC } from 'react';

import { GO_WOMBAT_LINK } from '../../../../config';

import { Icons, IconsTypes } from '@/components/shared/Icons';
import { Link } from '@/components/shared/Link';

export const Honor: FC = () => (
  <div className="flex items-center space-x-4">
    <p className="text-white md:text-base-md">
      <Trans i18nKey="footer.honor" />
    </p>

    <Link href={GO_WOMBAT_LINK} target="_blank">
      {Icons({ name: IconsTypes.WOMBAT })}
    </Link>
  </div>
);
